import React from 'react';
import Modal from 'react-responsive-modal';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('EXCHANGE_RATES_IMPORT_MODAL', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-max-width-65'
};

class ExchangeRatesImportModal extends React.Component {

    constructor(props) {
        super(props);
        log.debug('constructor(): ExchangeRatesImportModal: ', props);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    onCloseClick(event) {
        log.debug('onCloseClick(): event: ', event);
        this.props.onCloseClick();
    }

    render() {
        log.debug('render(): ', this.props);
        const {open} = this.props;
        return (
            <div data-test="component-exchange-rates-import-modal">
                <Modal center
                    classNames={MODAL_CLASSNAMES}
                    open={open}
                    closeOnOverlayClick={false}
                    onClose={this.onCloseClick}
                >
                    {this.props.titleLanguageString ? (<h2><LanguageStringResolver string={this.props.titleLanguageString} /></h2>) : ('')}
                    {this.props.children}
                </Modal>
            </div>
        );
    }
}


ExchangeRatesImportModal.defaultProps = {
    open: false,
    onCloseClick: () => {},
    titleLanguageString: ''
}

export default ExchangeRatesImportModal;
